import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import {
  simulatorReducer,
  SIMULATOR_FEATURE_KEY,
} from '../simulator/simulator.slice';
import { logger } from '../logger.middleware';
import { environment } from '../environments/environment';
import {
  UNIFIED_INBOX_KEY,
  inboxReducer,
  LOGIN_FEATURE_KEY,
  loginReducer,
  VOICE_PREFERNCE_FEATURE_KEY,
  voicePreferenceReducer,
  AGENT_STATE_KEY,
  agentStateReducer,
  CCF_CALL_CONFERENCE_FEATURE_KEY,
  ccfCallReducer,
  CCF_DIRECTORY_FEATURE_KEY,
  CCF_APP_SPACE_KEY,
  agentDirectoryReducer,
  GLOBAL_APP_FEATURE_KEY,
  globalReducer,
  UNIFIED_INTERACTION_KEY,
  interactionReducer,
  DISPOSITION_KEY,
  dispostionInteractionReducer,
  appSpaceReducer,
  CCF_CONVERSATIONS_FEATURE_KEY,
  ccfConversationsReducer,
  CCF_CHAT_CONFERENCE_FEATURE_KEY,
  ccfChatConferenceReducer,
  messageReducer,
  SMS_STATUS_KEY,
  ccfrtigReducer,
  CCF_RTIG_FEATURE_KEY,
  commitmentReducer,
  CCF_COMMITMENT_FEATURE_KEY,
  CCF_COPILOT_KEY,
  copilotReducer,
  CCF_LIVE_COPILOT_KEY,
  liveCopilotReducer,
  CCF_INTERACTION_SEARCH_FEATURE_KEY,
  ccfInteractionSearchReducer,
} from '@nice-ccf/ui-components';

export default configureStore({
  reducer: {
    [LOGIN_FEATURE_KEY]: loginReducer,
    [UNIFIED_INBOX_KEY]: inboxReducer,
    [SIMULATOR_FEATURE_KEY]: simulatorReducer,
    [VOICE_PREFERNCE_FEATURE_KEY]: voicePreferenceReducer,
    [CCF_CALL_CONFERENCE_FEATURE_KEY]: ccfCallReducer,
    [CCF_DIRECTORY_FEATURE_KEY]: agentDirectoryReducer,
    [AGENT_STATE_KEY]: agentStateReducer,
    [GLOBAL_APP_FEATURE_KEY]: globalReducer,
    [UNIFIED_INTERACTION_KEY]: interactionReducer,
    [CCF_CONVERSATIONS_FEATURE_KEY]: ccfConversationsReducer,
    [CCF_CHAT_CONFERENCE_FEATURE_KEY]: ccfChatConferenceReducer,
    [SMS_STATUS_KEY]: messageReducer,
    [DISPOSITION_KEY]: dispostionInteractionReducer,
    [CCF_APP_SPACE_KEY]: appSpaceReducer,
    [CCF_RTIG_FEATURE_KEY]: ccfrtigReducer,
    [CCF_COMMITMENT_FEATURE_KEY]: commitmentReducer,
    [CCF_COPILOT_KEY]: copilotReducer,
    [CCF_LIVE_COPILOT_KEY]: liveCopilotReducer,
    [CCF_INTERACTION_SEARCH_FEATURE_KEY]:ccfInteractionSearchReducer,
  },
  middleware: environment.production
    ? [...getDefaultMiddleware({ serializableCheck: false })]
    : [...getDefaultMiddleware({ serializableCheck: false }), logger],
});
